import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function IubireForWho() {
  const forWho = ['Persoane care simt lipsă de iubire în relații sau în interior. Te simți singură, nevăzută sau neîmplinită și vrei să înțelegi de ce și ce poți face.', 'Oameni care au trecut prin relații dureroase sau dezamăgiri și poartă resentimente sau răni emoționale nevindecate. Vor să se elibereze de trecut.', 'Persoane care nu se iubesc suficient și au stima de sine scăzută. Se judecă, se critică, se pun mereu pe ultimul loc și vor să schimbe asta.', 'Oameni interesați de vindecare emoțională și evoluție spirituală care vor să simtă iubirea profund, nu doar mental, ci la nivel de trăire reală.'];
  const notForWho = ['Persoane care caută soluții rapide fără implicare emoțională. Acest curs cere să te deschizi, să te privești cu sinceritate și să lucrezi cu emoțiile tale.', 'Cei care nu vor să lucreze cu trecutul lor. Dacă preferi să lași totul îngropat și să mergi mai departe fără să procesezi, acest curs nu e pentru tine.', 'Oameni complet închiși la ideea de dezvoltare personală sau spiritualitate. Cursul include meditații și practici care cer un minim de deschidere.'];
  return <section className="py-20 lg:py-32 bg-white relative" data-id="element-1462">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1463">
        <SectionHeading title="Pentru cine este cursul Abundența Iubirii" data-id="element-1464" />

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-1465">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-1466">
            <div className="flex items-center gap-4 mb-8" data-id="element-1467">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1468">
                <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-1469" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-1470">
                Este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-1471">
              {forWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-1472">
                  <CheckCircle2 className="w-5 h-5 text-green-500 mt-1 flex-shrink-0" data-id="element-1473" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-1474">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-1475">
            <div className="flex items-center gap-4 mb-8" data-id="element-1476">
              <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-1477">
                <AlertCircle className="w-6 h-6 text-red-600" data-id="element-1478" />
              </div>
              <h3 className="font-bold text-2xl text-brand-text" data-id="element-1479">
                NU este pentru tine dacă...
              </h3>
            </div>
            <ul className="space-y-5" data-id="element-1480">
              {notForWho.map((item, idx) => <li key={idx} className="flex gap-3 items-start" data-id="element-1481">
                  <AlertCircle className="w-5 h-5 text-red-400 mt-1 flex-shrink-0" data-id="element-1482" />
                  <span className="text-brand-text/80 leading-relaxed" data-id="element-1483">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-1484">
          <CTAButton data-id="element-1485" />
        </motion.div>
      </div>
    </section>;
}